module.exports = __webpack_public_path__ + "img/08_noff_close_L1.c5409cb9.svg";